import React, { Component } from 'react';
import { OuterComponent } from '../common/modal/StyledComponent';
import { Button, Form, FormGroup, Label, Row, Col, Input } from 'reactstrap';
import {
  getVerticals,
} from '../../services/api/offline-consult';
import {
  fetchLanguages,
} from '../../services/api/doctor';
import { fetchAllSponsors, searchDopeEntities } from '../../services/api/sponsors';
import { getOnlineConsultDoc } from '../../services/api/online-consultation-booking';
import LoadingComponent from '../common/LoadingComponent';
import Select from 'react-select';
import { Async } from 'react-select';
import debounce from 'lodash.debounce';
import { toast } from 'react-toastify';

export default class PlaceConsultRequestForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      verticalLoading: false,
      verticalsResult: [],
      languageLoading: false,
      languagesResult: [],
      sponsorsResult: [],
      doctorsLoading: false,
      verticalId: '',
      consultationLanguage: null,
      sponsorId: null,
      doctorId: '',
      sendSms: 0,
      requestedCallType: 'audio',
      consultationPayType: 'wallet',
      selectedEntityOption: null,
    };
    this.verticalSelectRef = React.createRef();
    this.languageSelectRef = React.createRef();
    this.sponsorSelectRef = React.createRef();
    this.doctorSelectRef = React.createRef();
    this.relativeSelectRef = React.createRef();

    this.debouncedLoadOptions = debounce(this._searchDoctors, 500);
    this.debouncedEntityLoad = debounce(this._searchDopeEntities, 500);
  }

  componentDidMount() {
    this.fetchVerticals();
    this.getLanguages();
    this.getSponsors();
  }

  fetchVerticals = () => {
    this.setState({ verticalLoading: true });
    getVerticals()
      .then((response) => {
        const arr = [];
        response.data.forEach((element) => {
          arr.push({ value: element.verticalId, label: element.verticalName });
        });
        this.setState({ verticalsResult: arr });
      })
      .finally(() => {
        this.setState({ verticalLoading: false });
      });
  };

  getLanguages = () => {
    this.setState({ languageLoading: true });
    const arr = [{ value: null, label: 'Any' }];
    fetchLanguages()
      .then((response) => {
        response.data.forEach((element) => {
          arr.push({ value: element.value, label: element.label });
        });
      })
      .finally(() => {
        this.setState({ languageLoading: false, languagesResult: arr });
      });
  };

  getSponsors = () => {
    this.setState({ languageLoading: true });
    const arr = [{ value: null, label: 'None' }];
    fetchAllSponsors()
      .then((response) => {
        response.data.forEach((element) => {
          arr.push({ value: element.sponsorId, label: element.sponsorName });
        });
      })
      .finally(() => {
        this.setState({ sponsorsResult: arr });
      });
  };

  _searchDoctors = (val, callback) => {
    console.log(val, 'inside search doc function[val]');
    const { verticalId, consultationLanguage } = this.state;
    if (!verticalId) {
      toast.error('Please select a vertical first');
      if (callback) callback([]);
      return;
    }
    this.setState({ doctorsLoading: true });
    getOnlineConsultDoc(val, verticalId, consultationLanguage)
      .then((response) => {
        const result = response.data || [];
        const options = result.map((ele) => {
          return {
            label: `${ele.docName} - ${ele.docId}`,
            value: ele.docId,
          };
        });
        if (callback) callback(options);
      })
      .catch((err) => {
        console.log(err);
        if (callback) callback([]);
      })
      .finally(() => {
        this.setState({ doctorsLoading: false });
      });
  };

  onSubmit = () => {
    console.log(
      '[new user form in PlaceBookConsultRequest component]',
    );
    const isWallet = this.state.consultationPayType === 'wallet';
    // For the wallet flow the dope entity is mandatory; the entity also carries
    // its sponsor, so entityId + sponsorId are taken from the same selection.
    if (isWallet && !this.state.selectedEntityOption) {
      toast.error('Please select an entity for the wallet booking.');
      return;
    }
    const entityId = isWallet && this.state.selectedEntityOption ? this.state.selectedEntityOption.value : null;
    const sponsorId = isWallet
      ? (this.state.selectedEntityOption ? this.state.selectedEntityOption.sponsorId : null)
      : this.state.sponsorId;

    this.props.placeSpecialistConsultRequest({
      doctorId: this.state.doctorId,
      relativeId: this.relativeSelectRef.current.state.value.value,
      prescriptionSms: this.state.sendSms ? 1 : this.state.sendSms,
      requestedCallType: this.state.requestedCallType,
      consultationLanguage: this.state.consultationLanguage,
      consultationPayType: this.state.consultationPayType,
      // entityId + sponsorId both come from the selected entity in the wallet flow
      sponsorId,
      entityId,
    });
  };

  // Sponsor dropdown (free flow only) — wallet flow takes the sponsor from
  // the selected entity instead.
  handleSponsorChange = (e) => {
    this.setState({ sponsorId: e ? e.value : null });
  };

  // Searchable entity dropdown (wallet flow). loadOptions for the Async select.
  // Each option carries its sponsorId so entity + sponsor stay together.
  _searchDopeEntities = (val, callback) => {
    searchDopeEntities(val)
      .then((response) => {
        const result = (response && response.data) || [];
        const options = result.map((ele) => ({
          label: ele.entityName,
          value: ele.entityId,
          sponsorId: ele.sponsorId,
        }));
        if (callback) callback(options);
      })
      .catch((err) => {
        console.log(err);
        if (callback) callback([]);
      });
  };

  handleEntityChange = (e) => {
    this.setState({ selectedEntityOption: e || null });
  };

  handleRequestedCallType = (type) => {
    this.setState({
      requestedCallType: type
    });
  };

  handleConsultationPayType = (type) => {
    this.setState({
      consultationPayType: type
    });
  };

  render() {
    console.log(this.props, this.state, 'render');

    return (
      <OuterComponent>
        <Form>
          <FormGroup>
            <Row>
              <Col className="col-3">
                <Label for="verticalSelect">Select Vertical</Label>
              </Col>
              <Col>
                <Select
                  name="verticalSelect"
                  id="verticalSelect"
                  isSearchable={true}
                  options={this.state.verticalsResult}
                  isLoading={this.state.verticalLoading}
                  onChange={(e) => this.setState({ verticalId: e ? e.value : '' })}
                />
              </Col>
            </Row>
          </FormGroup>
          <FormGroup>
            <Row>
              <Col className="col-3">
                <Label for="languageSelect">Select Language</Label>
              </Col>
              <Col>
                <Select
                  name="languageSelect"
                  id="languageSelect"
                  isSearchable={true}
                  options={this.state.languagesResult}
                  isLoading={this.state.languageLoading}
                  onChange={(e) => this.setState({ consultationLanguage: e ? e.value : null })}
                />
              </Col>
            </Row>
          </FormGroup>
          {this.state.consultationPayType === 'wallet' ? (
            <FormGroup>
              <Row>
                <Col className="col-3">
                  <Label for="entitySearch">Search Entity</Label>
                </Col>
                <Col>
                  <Async
                    name="entitySearch"
                    id="entitySearch"
                    cacheOptions={false}
                    defaultOptions
                    value={this.state.selectedEntityOption}
                    loadOptions={(val, callback) =>
                      this.debouncedEntityLoad(val, callback)
                    }
                    onChange={this.handleEntityChange}
                    placeholder="Search entity..."
                  />
                </Col>
              </Row>
            </FormGroup>
          ) : (
            <FormGroup>
              <Row>
                <Col className="col-3">
                  <Label for="sponsorSelect">Select Sponsor</Label>
                </Col>
                <Col>
                  <Select
                    name="sponsorSelect"
                    id="sponsorSelect"
                    isSearchable={true}
                    options={this.state.sponsorsResult}
                    onChange={this.handleSponsorChange}
                  />
                </Col>
              </Row>
            </FormGroup>
          )}
          <FormGroup>
            <Row>
              <Col className="col-3">
                <Label for="doctorSearch">Search Doctor:</Label>
              </Col>
              <Col>
                <Async
                  key={`${this.state.verticalId}-${this.state.consultationLanguage}`}
                  name="doctorSearch"
                  id="doctorSearch"
                  cacheOptions={false}
                  loadOptions={(val, callback) =>
                    this.debouncedLoadOptions(val, callback)
                  }
                  ref={this.doctorSelectRef}
                  onChange={(e) => this.setState({ doctorId: e ? e.value : '' })}
                  isLoading={this.state.doctorsLoading}
                />
              </Col>
            </Row>
          </FormGroup>
          <FormGroup>
            <Row>
              <Col className="col-3">
                <Label for="userPhoneNumber">Phone Number</Label>
              </Col>
              <Col>
                <Input
                  name="userPhoneNumber"
                  id="userPhoneNumber"
                  type="number"
                  value={this.props.phone ? this.props.phone : null}
                  onChange={(e) => this.props.getUserDetails(e.target.value)}
                />
              </Col>
            </Row>
          </FormGroup>
          <FormGroup>
            <Row>
              <Col className="col-3">
                <Label for="userName">User Name</Label>
              </Col>
              <Col>
                <Input
                  name="userName"
                  id="userName"
                  type="text"
                  value={`${this.props.userId}-${this.props.userName}`}
                  readOnly
                // disabled={true}
                />
              </Col>
            </Row>
          </FormGroup>
          <FormGroup>
            <Row>
              <Col className="col-3">
                <Label for="patientSelect">Relative</Label>
              </Col>
              <Col>
                <Row className="my-2">
                  <Col>
                    <Select
                      name="patientSelect"
                      id="patientSelect"
                      style={{ width: `100%` }}
                      isSearchable={false}
                      ref={this.relativeSelectRef}
                      defaultValue={
                        this.props.relativeResult.length > 0 &&
                        this.props.relativeResult[0]
                      }
                      options={this.props.relativeResult}
                      isLoading={this.props.relativeLoading}
                    />
                  </Col>
                </Row>
                <Row className="my-2">
                  <Col>
                    <Button
                      disabled={
                        !(this.props.userId && this.props.userName) ||
                        !this.props.canAddDependents
                      }
                      onClick={() => this.props.addDependentModalOpen()}
                    >
                      Add Dependent
                    </Button>
                  </Col>
                </Row>
                <Row className="my-2 mx-2">
                  <div style={{ display: 'flex' }}>
                    <Col>
                      <Input
                        name='consultationPayType'
                        id='consultationPayType'
                        type='checkbox'
                        value={this.state.consultationPayType}
                        checked={this.state.consultationPayType === 'wallet'}
                        onChange={() => this.handleConsultationPayType('wallet')}
                      />
                      <Label>Wallet</Label>
                    </Col>
                    <Col>
                      <Input
                        name='consultationPayType'
                        id='consultationPayType'
                        type='checkbox'
                        value={this.state.consultationPayType}
                        checked={this.state.consultationPayType === 'free'}
                        onChange={() => this.handleConsultationPayType('free')}
                      />
                      <Label>Free</Label>
                    </Col>
                  </div>
                </Row>
                <Row className="my-2 mx-2">
                  <div style={{ display: 'flex' }}>
                    <Col>
                      <Input
                        name='callType'
                        id='callType'
                        type='checkbox'
                        value={this.state.sendSms}
                        checked={this.state.requestedCallType === 'audio'}
                        onChange={() => this.handleRequestedCallType('audio')}
                      />
                      <Label>Audio</Label>
                    </Col>
                    <Col>
                      <Input
                        name='callType'
                        id='callType'
                        type='checkbox'
                        value={this.state.sendSms}
                        checked={this.state.requestedCallType === 'video'}
                        onChange={() => this.handleRequestedCallType('video')}
                      />
                      <Label>Video</Label>
                    </Col>
                  </div>
                </Row>
                <Row className="my-2 mx-2">
                  <Col>
                    <Input
                      name='sms'
                      id='sms'
                      type='checkbox'
                      value={this.state.sendSms}
                      onChange={() => this.setState({ sendSms: !this.state.sendSms })}
                    />
                    <Label>Send prescription sms</Label>
                  </Col>
                </Row>
              </Col>
            </Row>
          </FormGroup>
        </Form>
        <div className="flex flex-row justify-end">
          <div className="flex flex-col m-3">
            {this.props.loading ? (
              <LoadingComponent />
            ) : (
              <Button color="primary" onClick={this.onSubmit}>
                Book Consultation
              </Button>
            )}
          </div>
          <div className="flex flex-col m-3">
            <Button color="secondary" onClick={this.props.closeModal}>
              Close
            </Button>
          </div>
        </div>
      </OuterComponent>
    );
  }
}
